import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import TermsOfServiceComponent from "../components/TermsOfService"

const TermsOfServicePage = () => {
    return (
        <div className="font-sans text-gray-900 bg-gray-50 antialiased min-h-screen">
            <div className="sticky top-0 z-50">
                <Navbar />  
            </div>
            <main className="py-8">
                <TermsOfServiceComponent />
            </main>
            <Footer />
        </div>
    )
}

export default TermsOfServicePage
